const pubmedTheme = {
  dot: "bg-sky-400",
  accentText: "text-sky-200",
  subtleText: "text-sky-300",
  tabActive: "border-sky-400/40 bg-sky-500/10 text-sky-100",
  selectedRow: "border-l-2 border-sky-400 bg-sky-500/[0.08]",
  accentBadge: "border border-sky-400/30 bg-sky-500/10 text-sky-100",
  idBadge: "border border-sky-400/25 bg-sky-500/5 text-sky-100",
  detailBorder: "border-sky-400/25",
  detailGlow: "from-sky-400/25",
  checkbox:
    "border-sky-300/35 text-sky-200 hover:border-sky-200/55 hover:bg-sky-950/70 focus-visible:ring-sky-300/25",
  checkboxChecked:
    "border-sky-100/70 from-cyan-300 to-sky-400 shadow-[0_0_0_1px_rgba(186,230,253,0.16),0_10px_22px_rgba(14,165,233,0.24)]",
};

export default pubmedTheme;
